import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@livekit/components-styles';
import './styles.css';
import { HostHome } from './pages/HostHome';
import { MeetingPage } from './pages/MeetingPage';
import { RoomPage } from './pages/RoomPage';
import { tenant } from './tenant';
import { loadGuide } from './guide';

if(tenant.id==='tutor'){
  try{document.documentElement.dataset.theme=localStorage.getItem('tutor-video-theme')==='dark'?'dark':'light';}catch{document.documentElement.dataset.theme='light';}
  void loadGuide();
}

// Routes: "/" (sign-in, meetings, workspaces, calendar, people), "/w/<id>" (one workspace), "/m/<id>" (join and call),
// "/r/<workspace>?k=" (a workspace's standing room link).
function App() {
  const w = /^\/w\/([A-Za-z0-9_-]{12})\/?$/.exec(location.pathname);
  if (w) return <HostHome workspaceId={w[1]!} />;
  const m = /^\/m\/([a-z2-9]{10})\/?$/.exec(location.pathname);
  if (m) return <MeetingPage meetingId={m[1]!} link={new URLSearchParams(location.search).get('k')} />;
  const r = /^\/r\/([A-Za-z0-9_-]{12})\/?$/.exec(location.pathname);
  if (r) return <RoomPage workspaceId={r[1]!} roomKey={new URLSearchParams(location.search).get('k')} />;
  return <HostHome />;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
